import Text from '@passkeys/ui/text';

import BackButton from '../../back-button/index.js';

type FixedHeaderProps = {
  title: string;
  canClose?: boolean;
  onClose: () => void;
};

function FixedHeader({ title, canClose, onClose }: FixedHeaderProps) {
  return (
    <header className="flex size-full items-center justify-between">
      <div className="flex-1">
        {canClose && <BackButton onClick={() => onClose()} />}
      </div>
      <Text as="h1">{title}</Text>
      <div className="flex-1" />
    </header>
  );
}

export default FixedHeader;
